import React from "react";

import TooltipMessage from "./TooltipMessage";

import Popup from "@/shared/components/Popup/Popup";

import styles from "./Tooltip.module.scss";

const INITIAL_STATE = {
  message: null,
  isShown: false,
  target: null,
  targetRect: null,
  parentRect: null,
  allowMoveMouseOnTooltip: false,
};

const SHOW_DELAY = 150;

let _resetListener;

class TooltipWrap extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.timerRef = undefined;
    this.rootElementRef = React.createRef();
    this.hide = this.hide.bind(this);
    this.getResetAllListener = this.getResetAllListener.bind(this);
    this.show = this.show.bind(this);
  }

  // Pattern of this context saving.
  getResetAllListener() {
    if (_resetListener === undefined) {
      _resetListener = () => {
        this.hide();
      };
    }

    return _resetListener;
  }

  componentDidMount() {
    window.addEventListener("popstate", this.getResetAllListener());
  }

  componentWillUnmount() {
    const resetAllListener = this.getResetAllListener();
    resetAllListener();

    window.removeEventListener("popstate", resetAllListener);
  }

  show(message, e, parent, options) {
    let delayTimeout, targetRectCustom, allowMoveMouseOnTooltip;

    if (options) {
      delayTimeout = options.delayTimeout;
      targetRectCustom = options.targetRectCustom;
      allowMoveMouseOnTooltip = options.allowMoveMouseOnTooltip;
    }

    if (delayTimeout === undefined) {
      delayTimeout = SHOW_DELAY;
    }

    this.hide();

    e.persist && e.persist();

    let timerId;

    const target = e.target;
    const targetRect = targetRectCustom ?? (target ? target.getBoundingClientRect() : {});

    const parentRect = parent ? parent.getBoundingClientRect() : undefined;

    const listener = () => {
      if (timerId) {
        clearTimeout(timerId);
      } else {
        this.hide();
      }
    };

    const listenerOptions = {
      once: true,
      capture: true,
    };

    target.addEventListener("mouseleave", listener, listenerOptions);

    const show = () => {
      this.setState({
        isShown: true,
        message,
        allowMoveMouseOnTooltip,
        onHide: () => {
          target.removeEventListener("mouseleave", listener, listenerOptions);
        },
        target,
        targetRect,
        parentRect,
      });

      target.removeEventListener("mouseleave", listener, listenerOptions);
    };

    if (delayTimeout) {
      timerId = setTimeout(() => {
        timerId = undefined;

        show();
      }, delayTimeout);

      this.timerRef = timerId;
    } else {
      show();
    }
  }

  hide() {
    clearTimeout(this.timerRef);

    if (this.state.onHide) {
      this.state.onHide();
    }

    this.setState(INITIAL_STATE);
  }

  render() {
    const {
      message, isShown, target, targetRect, parentRect, allowMoveMouseOnTooltip
    } = this.state;
    return (
      <Popup
        ref={this.rootElementRef}
        className="tooltip"
        contentProps={{
          className: styles["root"],
        }}

        isShowPointer

        hideOnMouseLeave
        allowMoveMouseOnTooltip={allowMoveMouseOnTooltip}

        isUseLockBodyScroll={false}
        focusOnBecameVisible={false}
        hasBackdrop={false}
        preventCoverHeader={false}

        isShown={isShown}

        anchorEl={target}
        anchorRect={targetRect}
        boundaryRect={parentRect}

        maxHeight={256}

        onHide={this.hide}
      >
        <TooltipMessage message={message} />
      </Popup>
    );
  }
}

export default TooltipWrap;
